import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

export default function AuthSuccessPage() {
  const [error, setError] = useState<string | null>(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (!code) {
          setError("Brak kodu autoryzacji");
          return;
        }

        const res = await fetch(`${API_URL}/auth/exchange`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code }),
        });

        if (!res.ok) {
          const text = await res.text();
          setError(`Błąd logowania: ${text}`);
          return;
        }

        window.location.replace("/");
      } catch {
        setError("Nieoczekiwany błąd");
      }
    };

    run();
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #0f172a, #1e293b)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          borderRadius: 4,
          textAlign: "center",
          minWidth: 320,
        }}
      >
        {!error ? (
          <>
            <CircularProgress sx={{ mb: 3 }} size={48} thickness={4} />
            <Typography variant="h6" fontWeight={600}>
              Finalizowanie logowania...
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Proszę czekać, przygotowujemy Twoje środowisko
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" color="error" fontWeight={600}>
              {error}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Spróbuj ponownie
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
}